import React from "react";
import { Card, Col, Row, Form, Input, Button, Flex, Divider } from "antd";
import { MaskedInput } from "antd-mask-input";

import useCreate from "hooks/useCreate";
import useFormErrors from "hooks/useFormErrors";
import { name_with_numbers_regexp, nip_regexp } from "helpers/regexp";
import { useAuth } from "context/providers/auth";
import { useIssueKinds } from "context/providers/issue_kinds";

const Company = () => {
  const {
    state: {
      user: { company: data },
    },
    updateCompany,
  } = useAuth();
  const { data: issue_kinds } = useIssueKinds();
  const [form] = Form.useForm();
  const { pristine, has_error, onFieldsChange, reset } = useFormErrors(data);

  const path = "/companies";

  const { is_saving, create } = useCreate({
    path,
    form,
    success_message: "Zaktualizowano dane firmy",
    onSuccess: (company_data) => {
      updateCompany(company_data);
      reset();
    },
  });

  return (
    <Card
      title="Edytuj dane firmy"
      className="m-t-20"
      extra={
        <Button
          type="primary"
          htmlType="button"
          disabled={!issue_kinds.length}
          onClick={() =>
            window.open(
              `https://evertask.pl/${data?.slug}/zgloszenia`,
              "_blank"
            )
          }
        >
          Formularz publiczny
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFieldsChange={onFieldsChange}
        initialValues={{
          nip: data?.nip,
          name: data?.name,
          phone: data?.phone,
        }}
        onFinish={(values) => create(values)}
      >
        <Row gutter={24}>
          <Col xs={24}>
            <Form.Item
              label="Nazwa firmy"
              name="name"
              required
              hasFeedback
              rules={[
                {
                  pattern: name_with_numbers_regexp,
                  message: "Pole zawiera niedozolone znaki!",
                },
              ]}
            >
              <Input placeholder="Nazwa firmy" maxLength={128} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={12}>
            <Form.Item
              label="NIP"
              name="nip"
              required
              hasFeedback
              rules={[
                {
                  pattern: nip_regexp,
                  message: "Niepoprawny NIP",
                },
              ]}
            >
              <MaskedInput mask="0000000000" />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              label="Telefon kontaktowy"
              name="phone"
              required
              hasFeedback
              rules={[
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject(
                        new Error("Numer telefonu wymagany!")
                      );
                    }
                    if (value.includes("_")) {
                      return Promise.reject(
                        new Error("Numer telefonu niepoprawny!")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <MaskedInput mask="000000000" />
            </Form.Item>
          </Col>
        </Row>
        <Divider size="medium" className="m-t-5" />
        <Flex justify="flex-end" gap={16}>
          <Button
            disabled={pristine || has_error}
            loading={is_saving}
            type="primary"
            htmlType="submit"
          >
            Zapisz
          </Button>
        </Flex>
      </Form>
    </Card>
  );
};

export default Company;
